
import React, { useState } from 'react';
import axios from '../setupAxios';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { apiUrl } from '../config/api';
import { useAuth } from '../context/AuthContext';
import WindLogo from './WindLogo';

function getLoginRedirectPath(from) {
  if (!from?.pathname || from.pathname === '/login') {
    return '/';
  }
  return `${from.pathname}${from.search || ''}${from.hash || ''}`;
}

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated } = useAuth();
  const redirectTo = getLoginRedirectPath(location.state?.from);

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(apiUrl('/api/auth/login'), {
        username,
        password,
      });

      login(response.data.token, response.data.username, response.data.role, response.data.actk);

      navigate(redirectTo, { replace: true });
    } catch (err) {
      const status = err.response?.status;
      if (status === 403) {
        setError('登录被拒绝(403)：多为浏览器跨域(CORS)或网关拦截，请确认访问域名与 API 域名一致');
      } else if (status === 401) {
        setError('登录失败: 用户名或密码错误');
      } else {
        setError('登录失败，请稍后重试');
      }
      console.error('Login error:', err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-bg-layer login-bg-layer--mesh" aria-hidden="true" />
      <div className="login-bg-layer login-bg-layer--orb login-bg-layer--orb-1" aria-hidden="true" />
      <div className="login-bg-layer login-bg-layer--orb login-bg-layer--orb-2" aria-hidden="true" />
      <div className="login-bg-layer login-bg-layer--orb login-bg-layer--orb-3" aria-hidden="true" />
      <div className="login-bg-layer login-bg-layer--grid" aria-hidden="true" />

      <div className="login-card">
        <div className="login-card__header">
          <div className="login-card__logo login-card__logo--wind" aria-hidden="true">
            <WindLogo variant="mark" />
          </div>
          <h2>
            <WindLogo variant="login" />
          </h2>
          <p className="login-card__subtitle">欢迎回来，请登录您的账户</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">用户名</label>
            <div className="login-input-wrap">
              <i className="fa-solid fa-user login-input-wrap__icon" aria-hidden="true" />
              <input
                type="text"
                id="username"
                className="login-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="请输入用户名"
                autoComplete="username" maxLength={20} />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="password">密码</label>
            <div className="login-input-wrap">
              <i className="fa-solid fa-lock login-input-wrap__icon" aria-hidden="true" />
              <input
                type="password"
                id="password"
                className="login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="请输入密码"
                autoComplete="current-password"  maxLength={20} />
            </div>
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-btn">
            <i className="fa-solid fa-right-to-bracket" aria-hidden="true" />
            登录
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
